import { LitElement, html } from "lit";

import { customElement, property } from "lit/decorators.js";

import { styles } from "./router-link.css";

import { type RoutePath, navigateTo } from "../../router";

@customElement("router-link")
export class RouterLink extends LitElement {
  @property({ type: String })
  href!: RoutePath;

  static override styles = styles;

  private handleClick = async (event: MouseEvent) => {
    // Allow default behavior for special cases
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) {
      return;
    }

    event.preventDefault();
    await navigateTo(this.href);
  };

  private handleKeyDown = async (event: KeyboardEvent) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      await navigateTo(this.href);
    }
  };

  override render() {
    return html`
      <a href=${this.href} @click=${this.handleClick} @keydown=${this.handleKeyDown}>
        <slot></slot>
      </a>
    `;
  }
}
